import React from 'react';
import { Twitter, Linkedin, Instagram, Mail } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/gTDxox6zehr7hdBHYwo7U1/Main_Big_png.png';
export function Footer() {
  return <footer className="bg-[#0A1220] py-12 border-t border-white/5" data-id="element-11">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4" data-id="element-13">
          <div className="col-span-1 md:col-span-2" data-id="element-14">
            <div className="flex items-center gap-2 mb-4" data-id="element-15">
              <img src={LOGO_URL} alt="VeriProp" className="h-10 w-auto brightness-0 invert" data-id="element-16" />
            </div>
            <p className="max-w-xs text-sm text-slate-400" data-id="element-17">
              Your trusted bridge to property ownership in Nigeria. Secure,
              transparent, and hassle-free real estate solutions for the
              diaspora.
            </p>
          </div>

          <div data-id="element-18">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white" data-id="element-19">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-20">
              <li data-id="element-21">
                <a href="#" className="text-sm text-slate-400 hover:text-[#E8531E] transition-colors" data-id="element-22">
                  About Us
                </a>
              </li>
              <li data-id="element-23">
                <a href="#" className="text-sm text-slate-400 hover:text-[#E8531E] transition-colors" data-id="element-24">
                  Services
                </a>
              </li>
              <li data-id="element-25">
                <a href="#" className="text-sm text-slate-400 hover:text-[#E8531E] transition-colors" data-id="element-26">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-27">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white" data-id="element-28">
              Connect
            </h3>
            <div className="flex space-x-4" data-id="element-29">
              <a href="#" className="text-slate-400 hover:text-[#E8531E] transition-colors" data-id="element-30">
                <span className="sr-only" data-id="element-31">Twitter</span>
                <Twitter className="h-5 w-5" data-id="element-32" />
              </a>
              <a href="https://www.linkedin.com/company/veriprop/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-[#E8531E] transition-colors" data-id="element-33">
                <span className="sr-only" data-id="element-34">LinkedIn</span>
                <Linkedin className="h-5 w-5" data-id="element-35" />
              </a>
              <a href="https://www.instagram.com/veriprop.ai/" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-[#E8531E] transition-colors" data-id="element-36">
                <span className="sr-only" data-id="element-37">Instagram</span>
                <Instagram className="h-5 w-5" data-id="element-38" />
              </a>
              <a href="mailto:support@veriprop.ai" className="text-slate-400 hover:text-[#E8531E] transition-colors" data-id="element-39">
                <span className="sr-only" data-id="element-40">Email</span>
                <Mail className="h-5 w-5" data-id="element-41" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-white/5 pt-8" data-id="element-42">
          <p className="text-center text-xs text-slate-500" data-id="element-43">
            &copy; {new Date().getFullYear()} VeriProp. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}